import './bottom-menu.scss';

/**
 * version     1.0
 * class       BottomMenu
 * classdesc   Component that manages a dynamic Bootstrap Italia BottomMenu
 */
export class BottomMenu {
  constructor() {
    this.body = document.querySelector('body');
    this.cardsAccordion = document.querySelectorAll('.bottom-menu');
    if (this.cardsAccordion.length) {
      this.body.classList.add('has-bottom-menu');
    }
  }
}
